import React from 'react';
import { Button } from 'antd';
import moment from 'moment';
import { formatDateTime } from 'src/utils/utils';

const getOptionLabel = (options: any[], val: any): string => {
  const option = (options || []).find((opt: any) => opt.value === val);
  if (option) {
    return option.label || option.text || String(option.value);
  }
  return String(val);
};

/**
 * Render a custom-field value by its configured type.
 * `onViewJsonArray` is invoked when the user opens a jsonArray field's details,
 * letting each caller own its own modal state.
 */
export const renderCustomFieldValue = (
  value: any,
  field: any,
  t: any,
  onViewJsonArray?: (data: any[], fields: any[]) => void,
): JSX.Element | string => {
  if (value === null || value === undefined || value === '') {
    return '-';
  }
  switch (field.type) {
    case 'datetime': {
      const epoch = Number(value);
      const parsed = Number.isNaN(epoch) ? moment(value) : moment(epoch);
      return parsed.isValid() ? formatDateTime(parsed) : String(value);
    }
    case 'boolean':
      return value ? 'Yes' : 'No';
    case 'dropdown':
      if (field.multiselect) {
        const selected = Array.isArray(value) ? value : [value];
        return selected.map((val: any) => getOptionLabel(field.options, val)).join(', ');
      }
      return getOptionLabel(field.options, value);
    case 'jsonArray':
      return (Array.isArray(value) && value.length)
        ? (
          <Button
            type="link"
            style={{ padding: 0 }}
            onClick={() => onViewJsonArray?.(value, field.fields || [])}
          >
            {t('View Details')}
          </Button>
        )
        : '-';
    default:
      return typeof value === 'object' ? JSON.stringify(value) : String(value);
  }
};

export default renderCustomFieldValue;
